// extracted by mini-css-extract-plugin
module.exports = {"group":"AuthMenu_group__3B_m3","btn":"AuthMenu_btn__1qgV8","link":"AuthMenu_link__17v-h"};